import { render, staticRenderFns } from "./StudentEmpower.vue?vue&type=template&id=19ab4d4c&scoped=true&"
import script from "./StudentEmpower.vue?vue&type=script&lang=js&"
export * from "./StudentEmpower.vue?vue&type=script&lang=js&"
import style0 from "./StudentEmpower.vue?vue&type=style&index=0&id=19ab4d4c&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19ab4d4c",
  null
  
)

export default component.exports